<template>
  <el-dialog
    class="wait_view"
    :visible.sync="dialogVisible"
    :before-close="handleBeforeClose"
    width="74%"
    :close-on-click-modal="false"
  >
    <div class="wait_main" v-loading="isLoading">
      <el-carousel
        ref="myCarousel"
        trigger="click"
        height="50vh"
        :autoplay="false"
        :loop="false"
        indicator-position="none"
        arrow="always"
        @change="getFaceImgUrl"
      >
        <el-carousel-item v-for="(item, index) in waitExamine" :key="index">
          <!-- <h1>{{ index + faceImg }}</h1> -->
          <p class="hader">
            <span>名称：{{ item.RealName }}</span
            ><span>科室：{{ item.DepartmentName }}</span
            ><span>职称：{{ item.PTitle }}</span>
          </p>
          <div class="img_view">
            <el-image
              style="
                width: 50%;
                height: 90%;
                margin-top: 24px;
                border: 4px solid #f2f2f2;
                border-radius: 24px;
              "
              :src="faceImg"
              :preview-src-list="srcList"
              fit="cover"
            >
            </el-image>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="submit(2)">不通过</el-button>
      <el-button type="primary" @click="submit(1)">通过</el-button>
      <el-button type="primary" style="margin: 0" @click="handleBeforeClose"
        >退出审核</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import loginvuex from "@/store/index";
import systemclass from "@/api/systemclassification";
export default {
  data() {
    return {
      dialogVisible: false,
      isLoading: false,
      faceImg: "",
      srcList: [],
      row: {},
    };
  },
  props: ["waitExamine", "rowObj", "filterExamList", "getDatalist"],
  methods: {
    handleBeforeClose() {
      this.getDatalist("treat"); // 获取待审批人数
      this.getDatalist(); // 获取待审批人数
      this.dialogVisible = false;
    },
    submit(type) {
      const obj = {
        hid: JSON.parse(loginvuex.state.userlist).hid,
        isPass: type,
        studentArr: `[${this.row.UserID}]`, // 考生ID
      };
      //   this.filterExamList(this.row.UserID);
      // console.log(this.waitExamine);
      //   return;
      this.$confirm(
        `此操作将考生名为${this.row.RealName}<span class="${
          type == 2 ? "red" : "green"
        }">${type == 2 ? "不通过审核" : "通过审核"}</span>, 是否继续?`,
        "温馨提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          const { data } = await systemclass.updateFaceAuth(obj);
          if (data.Status == 200) {
            this.$message({
              message: `考生${this.row.RealName}${
                type == 2 ? "不通过审核" : "通过审核"
              }提交成功！`,
              type: "success",
            });
            this.filterExamList(this.row.UserID);

            // 成功后从轮播数组里过滤掉当前数据
          } else {
            this.$message.error(data.Msg);
          }
        })
        .catch(() => {});
    },
    // 获取图片
    async getFaceImgUrl(val, type) {
      this.isLoading = true;
      console.log(this.waitExamine[val]);
      const obj = {
        hid: JSON.parse(loginvuex.state.userlist).hid,
        studentID: "",
        isPassList: 0, // 来源0审核列表 1考生编辑列表
      };
      if (type === "init" || type === "sieve") {
        let zindex = 0; // 找出列表查看的一项数据
        this.waitExamine.forEach((item, index) => {
          if (item.UserID == val) {
            zindex = index;
          }
        });
        if (type === "init") {
          this.$refs.myCarousel.setActiveItem(zindex);
        }
        obj.studentID = val;
        this.row = this.waitExamine[zindex];
      } else {
        obj.studentID = this.waitExamine[val]?.UserID;
        this.row = this.waitExamine[val];
      }
      if (obj.studentID) {
        const { data } = await systemclass.getFaceImg(obj);
        if (data.Status == 200) {
          this.faceImg = data.Data.faceImg;
          this.srcList = [];
          this.srcList.push(data.Data.faceImg);
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        } else {
          this.$message.error(data.Msg);
          this.isLoading = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-icon-close {
  font-size: 28px;
}
::v-deep .el-dialog__body {
  padding: 0px !important;
  background: #dceeff !important;
}
::v-deep .el-dialog__header {
  background: #dceeff !important;
}
::v-deep .el-dialog__footer {
  background: #dceeff !important;
}
.el-carousel {
  width: 100%;
  background: #dceeff;
}
.hader {
  font-size: 24px;
  > span {
    margin-right: 48px;
  }
}
.wait_main {
  min-height: 60vh !important;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    text-align: center;
  }
}
.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  > .el-button {
    width: 120px;
    letter-spacing: 2px;
    margin-right: 120px;
    &:nth-child(1) {
      background: #e54d4d;
      color: #fff;
    }
    &:nth-child(2) {
      background: #00d254;
      border-color: #00d254;
    }
    &:nth-child(3) {
      background: #64b5ff;
    }
  }
}
.img_view {
  display: flex;
  justify-content: center;
  align-items: center;
//   border: 1px solid #000;
  height: 90%;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

// .el-carousel__item:nth-child(2n) {
//   background-color: #99a9bf;
// }

// .el-carousel__item:nth-child(2n + 1) {
//   background-color: #d3dce6;
// }
::v-deep .el-carousel__arrow {
  width: 80px;
  height: 80px;
  background: #dceeff;
  > i {
    font-size: 48px;
    color: #333333 !important;
  }
}
::v-deep .el-image{
    >img{
        width: 100% !important;
        height: 100% !important;
        
    }
}
</style>
<style>
.green {
  color: #00d254;
}
.red {
  color: #e54d4d;
}
</style>